export default __webpack_public_path__ + "static/media/place-or.da875e5f.png";